import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Coffee, Heart, Pill } from 'lucide-react';
export function WhyItFailed() {
  const reasons = [{
    icon: Moon,
    title: 'Melatonin',
    desc: "Often leads to 'hormonal hangovers' and vivid nightmares because it doesn't lower your cortisol; it just masks it."
  }, {
    icon: Coffee,
    title: 'Quitting Caffeine',
    desc: "Nearly impossible when you're already running on empty, and usually leads to a crash that triggers even more stress."
  }, {
    icon: Heart,
    title: "Standard 'Self-Care'",
    desc: "Baths or meditation feels like another chore on your to-do list and doesn't address the physical 'trapped' chemicals in your system."
  }, {
    icon: Pill,
    title: 'Multivitamins',
    desc: 'Too broad and rarely contain the specific micro-minerals your adrenals are currently screaming for.'
  }];
  return <section className="bg-cream-100 py-24 px-6" data-id="element-190">
      <div className="container mx-auto max-w-6xl" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-192">
          <span className="text-gold-600 font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-193">
            The Frustration
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-6" data-id="element-194">
            Why What You Tried Didn't Work
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-195">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-200 hover:shadow-md transition-shadow" data-id="element-196">
              <div className="flex items-start gap-6" data-id="element-197">
                <div className="bg-cream-100 p-4 rounded-xl text-gold-600 shrink-0" data-id="element-198">
                  <reason.icon size={24} data-id="element-199" />
                </div>
                <div data-id="element-200">
                  <h3 className="font-serif text-2xl text-navy-800 mb-3" data-id="element-201">
                    {reason.title}
                  </h3>
                  <p className="text-navy-700/80 leading-relaxed font-light" data-id="element-202">
                    {reason.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}